jQuery( document ).ready( function ( $ ) {

	function setOrder() {
		const card = document.querySelector( '.extended-description:not(.unseen)' );

		if ( !card ) {
			return;
		}

		const index = 1 + + card.dataset.id;

		const columns = getCardsInRow();
		let row = 1;

		while ( index > row * columns ) {
			row ++;
		}

		card.style.order = String( row * columns );

		scrollToOpenCard($(card));
		addingSliders(card);
		ssFunctionality(document.querySelector( '.extended-description:not(.unseen)' ));
	}

	function scrollToOpenCard (selector) {
		const el = typeof selector === 'string' ? $(selector) : selector;
		setTimeout(() => {
			$( 'html, body' ).animate( {
				scrollTop: el.offset().top - (
					100 + parseInt( el.css( 'padding-top' ) )
				)
			}, 500 );
		}, 200);
	}

	function getCardsInRow() {
		const screenWidth = + document.documentElement.clientWidth;

		if ( 480 >= screenWidth ) {
			return 1;
		}

		if ( 900 >= screenWidth ) {
			return 2;
		}

		if ( 1440 >= screenWidth ) {
			return 3;
		}

		return 4;


	}

	function debounce( func, timeout = 1000 ) {
		let timer;
		return ( ...args ) => {
			clearTimeout( timer );
			timer = setTimeout( () => {
				func.apply( this, args );
			}, timeout );
		};
	}

	function addingSliders(bigCard, oldBig) {
		if ($(bigCard).children('.clients-slider' ).length && $(bigCard).children('.testimonials-slider' ).length) {
			let currentSlickClients = $(bigCard).children('.clients-slider' );
			let currentSlickTestimonials = $(bigCard).children('.testimonials-slider' );
			let dotsWrapper = $(bigCard).children('.slider-nav-dots');

			const clientSlider = initCustonSliderNav(
				$(currentSlickClients),
				$('.our-clients .slider-nav-dots'),
				{
					dots: false,
					arrows: true,
					infinite: false,
					speed: 500,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: false,
					autoplaySpeed: 3000,
					mobileFirst: true,
					accessibility: true,
					draggable: true,
					asNavFor: $( currentSlickTestimonials ),
					focusOnSelect: true,
					responsive: [
						{
							breakpoint: 767,
							settings: {
								//dots: true,
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						},
					]
				})

			const contentSliderSettings = {
				dots: false,
				arrows: false,
				infinite: false,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				autoplay: false,
				draggable: false,
				swipeToSlide: false,
				swipe: false,
				accessibility: false,
				asNavFor: $( currentSlickClients ),
			};

			$( currentSlickTestimonials ).not('.slick-initialized').slick( contentSliderSettings );

		}

		if ($(oldBig).children('.slick-initialized' ).length ) {
			let currentSlickClients = $(oldBig).children('.clients-slider' );
			let currentSlickTestimonials = $(oldBig).children('.testimonials-slider' );
			$( currentSlickClients ).slick('unslick');
			$( currentSlickTestimonials ).slick('unslick');
		}
	}

	function ssFunctionality(bigCard) {
		let ssWrapper = bigCard.querySelector('.one-item') || bigCard.querySelector('.two-item') || bigCard.querySelector('.three-item') || bigCard.querySelector('.more-than-three-item');
		let allSSblocks = bigCard.querySelectorAll('.ss-block--content');
		if (window.innerWidth >= 768 && ssWrapper) {
			ssWrapper.addEventListener('mouseover', (event)=>{

				allSSblocks.forEach((element)=>{
					if(element.classList.contains('first-active')) {
						element.classList.remove('first-active')
					}
				})
				if (event.target.classList.contains('ss-block--content')  || event.target.closest('.ss-block--content')) {
					let currentSS = event.target.classList.contains('ss-block--content')  ?
						event.target : event.target.closest('.ss-block--content') ? event.target.closest('.ss-block--content') : false ;

					currentSS.classList.add('first-active');
				}
			})
			allSSblocks.forEach((element)=>{
				element.addEventListener('click', (elem)=>{
					let link = element.querySelector('.link-for-one-ss').getAttribute('href');
					document.location.href = `${link}`;
				})
			})

		} else if (window.innerWidth < 768 && ssWrapper) {
			ssWrapper.addEventListener('click', (event)=>{

				allSSblocks.forEach((element)=>{
					if(element.classList.contains('first-active')) {
						element.classList.remove('first-active')
					}
				})
				if (event.target.classList.contains('ss-block--content')  || event.target.closest('.ss-block--content')) {

					let currentSS = event.target.classList.contains('ss-block--content')
						? event.target
						: event.target.closest('.ss-block--content')
							? event.target.closest('.ss-block--content')
							: false ;

					currentSS.classList.add('first-active');
				}
			})
		}
	}

	setOrder();

	const processChange = debounce( () => setOrder() );

	window.addEventListener( 'resize', function () {
		processChange();
	} );

	document.addEventListener( 'click', function ( e ) {
		const btnMore = e.target.closest( '.extended-list__item' ) || e.target.closest( '.button-block.see-less' );
		const btnLess = e.target.closest( '.button-block.see-less' );
		if ( !btnMore ) {
			return true;
		}

		const oldSmall = document.querySelector( '.extended-list__item.active' );
		const oldBig = document.querySelector( '.extended-description:not(.unseen)' );

		const smallCard = btnMore.closest( '.extended-list__item' ) || btnLess.closest( '.extended-description' );
		const targetId = smallCard.dataset.target || smallCard.dataset.id;
		const bigCard = document.querySelector( `.extended-description[data-id="${targetId}"]` );

		smallCard.classList.add( 'active' );
		bigCard.classList.remove( 'unseen' );
		oldSmall?.classList.remove( 'active' );
		oldBig?.classList.add( 'unseen' );
		if(oldBig) {
			scrollToOpenCard('.extended-description:not(.unseen)');
		}


		setOrder();
		//
		addingSliders(bigCard, oldBig);
		//
		ssFunctionality(bigCard);

	} );

	function removeClassFunction(itemsArray, currentClass) {
		$( itemsArray ).each( function ( item ) {
			if ( $( this ).hasClass( currentClass ) ) {
				$( this ).removeClass( currentClass )
			}
		} )
	}
	if ($(body).attr('data-zoom') > 12 )  {
		$('.our-clients-extended-section').addClass('zoom');
		processChange();
	} else {
		removeClassFunction('.our-clients-extended-section', 'zoom');
		processChange();
	}
	$(document).on('accessibilityPreEvent', function (e) {
		if (e.originalEvent.detail['counter'] > 12) {
			$('.our-clients-extended-section').addClass('zoom');
			processChange();
		} else {
			removeClassFunction('.our-clients-extended-section', 'zoom');
			processChange();
		}
	});
} );
